import type { IKeytipProps } from "@fluentui/react";
import { memoizeFunction } from "@fluentui/react";

import { getDefaultKeytipProps } from "@1js/acui-keytip";

export const derivePreviewFlyoutKeytip = memoizeFunction(
  (keytipProps?: IKeytipProps): IKeytipProps | undefined => {
    return keytipProps ? getDefaultKeytipProps(keytipProps, 29) : undefined;
  }
);
